const StatsConsommationIntegrated = ({language , token}) => {
    const newStatsConsommationIframe = "https:" +
    window.process.env.URL_StatsConsommation
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_statsConsommation_display"
        src={newStatsConsommationIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsConsommationIntegrated